import { SET_NOTIFICATIONS_ENABLED, SET_SOUND_ENABLED } from './types';

export function setNotificationsEnabled(isEnabled) {
    return {
        type: SET_NOTIFICATIONS_ENABLED,
        payload: isEnabled,
    };
}

export function setSoundEnabled(isEnabled) {
    return {
        type: SET_SOUND_ENABLED,
        payload: isEnabled,
    };
}
